// extracted by mini-css-extract-plugin
module.exports = {"container":"CommentDoc__container___1vL4N","quote":"CommentDoc__quote___4_JaZ","source":"CommentDoc__source___2DVuo"};